import Preloader from 'components/Preloader'
import loadable from 'utils/loadable'

export default loadable(() => import('containers/Reports'), {
  fallback: <Preloader />,
})